<template id="switch-button">
	<div class="switch-button-control" :title="title">
		<div v-if="leftPosition" @click="toggle" class="switch-button-label">
			<slot></slot>
		</div>
		<div class="switch-button" :class="{ enabled: isEnabled }" @click="toggle" :style="{ '--color': isEnabled ? colorEnabled : colorDisabled, '--height': height }">
			<div class="button"></div>
		</div>
		<div v-if="!leftPosition" @click="toggle" class="switch-button-label">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		isEnabled: Boolean,
		leftPosition: Boolean,
		colorEnabled: {
			type: String,
			required: true,
		},
		colorDisabled: {
			type: String,
			default: '#ccc',
		},
		title: {
			type: String,
			required: false,
		},
		height: {
			type: String,
			required: false,
			default: '1em',
		},
	},

	model: {
		prop: 'isEnabled',
		event: 'toggle',
	},

	data() {
		return {};
	},

	methods: {
		toggle() {
			this.$emit('toggle', !this.isEnabled);
		},
	},
};
</script>

<style lang="scss">
.switch-button-control {
	display: flex;
	flex-direction: row;
	align-items: center;

	.switch-button {
		$switch-button-height: var(--height);
		$switch-button-color: var(--color);
		$switch-button-border-thickness: calc(var(--height) / 10);
		$switch-transition: all 0.3s ease-in-out;
		$switch-is-rounded: true;

		height: $switch-button-height;
		width: calc(#{$switch-button-height} * 2);
		border: $switch-button-border-thickness solid $switch-button-color;
		box-shadow: inset 0px 0px $switch-button-border-thickness 0px rgba(0, 0, 0, 0.33);
		border-radius: if($switch-is-rounded, $switch-button-height, 0);

		transition: $switch-transition;

		$button-side-length: calc(#{$switch-button-height} - (2 * #{$switch-button-border-thickness}));

		cursor: pointer;

		.button {
			height: $button-side-length;
			width: $button-side-length;
			border: $switch-button-border-thickness solid $switch-button-color;
			border-radius: if($switch-is-rounded, $button-side-length, 0);
			background: white;

			transition: $switch-transition;
		}
		background-color: #ccc;
		&.enabled {
			background-color: $switch-button-color;
			box-shadow: none;
			opacity: 1;

			.button {
				background: white;
				transform: translateX(calc(#{$button-side-length} + (2 *#{$switch-button-border-thickness})));
			}
		}
	}

	.switch-button-label {
		cursor: pointer;
	}
}
</style>
